/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ notes: NonNullable<unknown> }} Transcript_Export_Notes_LabelInputs */



/**
* | output |
* | --- |
* | "NOTES: {notes}" |
*
* @param {Transcript_Export_Notes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_notes_label = /** @type {((inputs: Transcript_Export_Notes_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Notes_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`NOTES: ${i?.notes}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`ANMERKUNGEN: ${i?.notes}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`NOTE: ${i?.notes}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`ПРИМЕЧАНИЯ: ${i?.notes}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`NOTAS: ${i?.notes}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`备注：${i?.notes}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`注記: ${i?.notes}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`टिप्पणियाँ: ${i?.notes}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`NOTAS: ${i?.notes}`)
	return /** @type {LocalizedString} */ (`NOTES: ${i?.notes}`)
});